module.exports = __webpack_public_path__ + "img/tobias-reich-sC5ZgFyGB4Y-unsplash@2x.a2530a51.png";